import { useQuery } from '@tanstack/react-query';
import api from '@/lib/axios';

export interface Category {
    _id: string;
    name: string;
    slug: string;
    description?: string;
    image?: {
        url: string;
        publicId: string;
    };
    parent?: string;
    subcategories?: Category[];
    isActive: boolean;
    order?: number;
}

export interface CategoriesResponse {
    success: boolean;
    data: Category[];
}

export const categoryKeys = {
    all: ['categories'] as const,
    public: () => [...categoryKeys.all, 'public'] as const,
};

export function useCategories() {
    return useQuery({
        queryKey: categoryKeys.public(),
        queryFn: async (): Promise<Category[]> => {
            const response = await api.get<CategoriesResponse>('/categories');
            return response.data.data;
        },
        staleTime: 1000 * 60 * 30, // 30 minutes
    });
}
